import { RequiredTranslationsTemplate } from '.'

const de: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Deutsch',
  },
  home: {
    title: 'PRODUKTRÜCKRUF ROCKRIDER XC 500 S',
    description:
      'Du hast ein MTB Rockrider XC 500 S gekauft und wir bedanken uns für deinen Einkauf. Im Rahmen von Kontrollen hat das Team unserer Marke für Mountainbikes einen möglichen Defekt an der Federgabel entdeckt. Nur die Fahrräder aus einer bestimmten Seriennummer sind betroffen. Wir bitten dich daher, die letzten sechs Ziffern der Seriennummer deines Fahrrads einzugeben, damit du weißt, ob dein Fahrrad von diesem Produktrückruf betroffen ist.',
    form: {
      title: 'Bitte gib deine Daten hier ein:',
      fields: {
        serialNumber: 'Seriennummer',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Vorname',
        lastName: 'Name',
        email: 'E-Mail',
        phone: 'Tel.',
        country: 'Land',
        submit: 'Bestätigen',
        choose: 'Auswählen...',
      },
      errors: {
        requiredField: 'Dieses Feld ist erforderlich',
        unknownSerialNumber: 'Unbekannte Seriennummer',
        provide6Numbers: 'Achtung, 6 Ziffern sind erforderlich',
      },
      confirmations: {
        good: {
          title: 'Dein Fahrrad ist nicht betroffen.',
          p1: 'Dein Fahrrad ist von diesem Produktrückruf nicht betroffen und du kannst es weiterhin vollkommen sicher benutzen.',
          p2: 'Wir entschuldigen uns für die Unannehmlichkeiten.',
          p3: 'Mit sportlichen Grüßen',
          p4: 'Dein DECATHLON Team',
        },
        defective: {
          title: 'Dein Fahrrad ist von diesem Produktrückruf betroffen',
          p1: 'Wir bitten dich, das Fahrrad nicht mehr zu benutzen und es zum nächstgelegenen DECATHLON Servicepoint zu bringen, um die Federgabel austauschen zu lassen.',
          p2: 'Bitte beachte, dass die Reparatur bis zu mehrere Tage in Anspruch nehmen könnte und du das Fahrrad in diesem Zeitraum nicht nutzen kannst. Wir bemühen uns, die Wartezeiten für dich so kurz wie möglich zu halten. Wir möchten dir dennoch dazu raten, dich direkt mit dem Servicepoint deiner  Stammfiliale in Verbindung zu setzen, um eine Schätzung zur Dauer der Reparatur zu erhalten.',
          p3: 'Hier kannst du einen Servicepoint in deiner Nähe finden:',
          decathlonLocatorLink: 'https://www.decathlon.de/store-locator',
          p4: 'Und hier findest du den Reparaturschein, den du bitte am Servicepoint für die Reparatur vorlegst:',
          p5: 'Unser Kundendienst steht dir von Montag bis Freitag von 9:00 bis 17:00 Uhr und Samstag von 10:00 bis 18:00 Uhr unter der Rufnummer +49 (0) 6202 97 81 300 für Fragen jeglicher Art zur Verfügung. Wir bedanken uns für dein Verständnis und entschuldigen uns für die Unannehmlichkeiten.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Wo finde ich die Seriennummer?',
      description: 'Die Seriennummer befindet sich unten am Rahmen, auf Höhe der Pedale.',
    },
  },
}

export default de
